import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API, PATIENT_API } from '../ApiNames';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
// import { fetchFamilyData } from '../reduxactions/patientactions/PatientFamilyActions';
import { fetchFamilyData } from '../reduxactions/patientactions/PatientFamilyActions';
export const PatientFamily = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.patientfamily.family);

    const dispatch = useDispatch();


    const toast = useRef(data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchFamilyData(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchDataAsync();
    }, [dispatch]);



    const [addDilog, setaddDilog] = useState(false);
    const toast1 = useRef<Toast>(null);
    const toast2 = useRef<Toast>(null);

    const [lastname, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setpassword] = useState('');
    const addVolunteerDataAsync = async () => {
        if (!lastname && !email && !password) {
            toast.current.show({ severity: 'error', detail: 'Please fill in all required fields.', life: 3000 });
            return;
        }
        try {
            const payload = { email: email, lname: lastname, password: password, uid: uid, q: 2 };
            const apiname = PATIENT_API.addfamily_API;
            const response = await LoginService.getData(apiname, payload);
            if (response === 'Successfully Added') {
                if (toast1.current) {
                    toast1.current.show({ severity: 'success', detail: response });
                }
            } else {
                if (toast1.current) {
                    toast1.current.show({ severity: 'info', detail: response });
                }
            }
            fetchDataAsync();
            setaddDilog(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [removedata, setRemoveData] = useState({
        PatientID: '',
    });

    const Removeduring = (rowData: any) => {
        setRemoveData({
            PatientID: rowData.PatientID,
        });
        setDeleteConfirmation(true);
    }

    const confirmDelete = async () => {
        const { PatientID } = removedata;
        const payload = { patientid: PatientID, primaryid: uid, q: 5 };
        const apiname = PATIENT_API.family_API;
        const data = await LoginService.getData(apiname, payload);
        if (toast2.current) {
            toast2.current.show({ severity: 'error', detail: data });
        }
        setDeleteConfirmation(false);
        fetchDataAsync()
    };

    const Close = () => {
        setaddDilog(false);
        setDeleteConfirmation(false);
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/patientfamily.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Patient Family List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="Add Family" severity="info" onClick={() => setaddDilog(true)} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['firstname', 'lastname', 'userEmail', 'Status']}>
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column body={(rowData) => `${rowData.firstName} ${rowData.lastName}`} sortable header="Patient Name"></Column>
                                                <Column field="userEmail" sortable header="Email ID"></Column>
                                                <Column header="Operation" body={(rowData) => (
                                                    <>
                                                        <Button className='mr-6' tooltip="Delete" severity="danger" icon="pi pi-trash" rounded outlined onClick={() => Removeduring(rowData)} />
                                                    </>
                                                )} />
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Dialog header="Add Family" visible={addDilog} style={{ width: '32vw', height: '51vh' }} onHide={() => setaddDilog(false)} >
                <div className="grid pt-0">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Email:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Email'
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                </div>
                <div className="grid pt-0" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Password:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Password'
                            onChange={(e) => setpassword(e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid pt-0">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '10px', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter LastName'
                            onChange={(e) => setLastName(e.target.value)}
                        />

                    </div>
                </div>

                <Button label="Close" onClick={() => setaddDilog(false)} severity="secondary" />
                <Button label="Add" onClick={addVolunteerDataAsync} style={{ float: 'right' }} />
            </Dialog >

            < Dialog header="Conform Delete " style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Close" onClick={Close} className="mr-3 p-button-secondary" />
                <Button label="Delete" className='mr-3 p-button-raised' onClick={confirmDelete} />
            </Dialog >

            <Toast ref={toast} ></Toast>
            <Toast ref={toast1} ></Toast>
            <Toast ref={toast2} ></Toast>

        </div>
    )
}
